import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/whatsapp-usage")({
  component: lazyRouteComponent(() => import("./-pages/admin.whatsapp-usage")),
  head: () => ({
    meta: [
      { title: "WhatsApp Usage · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
